// extracted by mini-css-extract-plugin
export default {"spinner":"ny3UlOE7AkENaQ7ev6pA","spin":"hZEKd7UhaIDRJZe21t49"};